let baseEventAttrs = {};
export const setVideoEventAttributes = (props) => {
    baseEventAttrs = {
        ...baseEventAttrs,
        ...props,
    };
};
export const clearVideoEventAttributes = () => {
    baseEventAttrs = {};
};
export const addDefaultAttributes = (eventsManager, getCurrentCustomAttributes) => {
    const newEventsManager = {
        addEvent: (eventName, eventProps, ...rest) => eventsManager.addEvent(eventName, { ...getCurrentCustomAttributes(), ...baseEventAttrs, ...eventProps }, ...rest),
    };
    return newEventsManager;
};
//# sourceMappingURL=EventsManager.js.map